/**
 * Purchase Invoice Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.purchaseInvoiceDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
